export const environment = {
  production: false,
  StarAPIURL: 'https://cfcustarapi-training.azurewebsites.net/',
  appID: 'f2ee36e5-2496-4b9a-a031-75f732dc7a24',
  scopes: ['https://cfcustarapi-training.azurewebsites.net/user_impersonation'],
  redirectUri: 'https://star-train.connectfirstcreditunion.net/home'
};
